import { AvailableNotificationViewModel, NotificationKind } from "client/Api/Notifications/notifications";
import { ReactElement } from "react";
import { CrossStoreActivity } from "./CrossStoreActivity";
import { never } from "client_legacy/ndaw/errors";
import { MaintenanceActivity } from "./MaintenanceActivity";
import { AnnouncementActivity } from "./AnnouncementActivity";
import { NewMainAppPromotionActivity } from "./NewMainAppPromotionActivity";
import { CustomActivity } from "./CustomActivity";
import { NewEmailActivity } from "./NewEmailActivity";
import { AppAccessActivity } from "./AppAccessActivity";
import { UserRequestActivity } from "./UserRequestActivity";
import { BirthdayActivity } from "./BirthdayActivity";
import { BirthdayWishActivity } from "./BirthdayWishActivity";
import { AnnouncementCommentActivity } from "./AnnouncementCommentActivity";
import { DocumentSharedActivity } from "./DocumentSharedActivity";
import { KnowledgeItemActivity } from "./KnowledgeItemActivity";
import { BirthdayWishReactionActivity } from "./BirthdayWishReactionActivity";
import { EventActivity } from "./EventActivity";
import { AnnouncementCommentReactionActivity } from "./AnnouncementCommentReactionActivity";
import { AnnouncementReactionActivity } from "./AnnouncementReactionActivity";
import { EventAttendanceActivity } from "./EventAttendanceActivity";
import { AnnouncementCommentMentionActivity } from "./AnnouncementCommentMentionActivity";
import { CommunityPostCommentActivity } from "./CommunityPostCommentActivity";
import { CommunityPostCommentMentionActivity } from "./CommunityPostCommentMentionActivity";
import { CommunityPostActivity } from "./CommunityPostActivity";
import { CommunityPostCommentReactionActivity } from "./CommunityPostCommentReactionActivity";
import { CommunityPostReactionActivity } from "./CommunityPostReactionActivity";
import { EventCommentReactionActivity } from "./EventCommentReactionActivity";
import { EventCommentActivity } from "./EventCommentActivity";
import { EventReactionActivity } from "./EventReactionActivity";
import { EventCommentMentionActivity } from "./EventCommentMentionActivity";
import { KnowledgeItemCommentActivity } from "./KnowledgeItemCommentActivity";
import { KnowledgeItemCommentReactionActivity } from "./KnowledgeItemCommentReactionActivity";
import { KnowledgeItemCommentMentionActivity } from "./KnowledgeItemCommentMentionActivity";
import { KnowledgeItemReactionActivity } from "./KnowledgeItemReactionActivity";
import { CommunityActivity } from "./CommunityActivity";
import { CommunityMembershipActivity } from "./CommunityMembershipActivity";
import { CommunityMembershipRequestActivity } from "./CommunityMembershipRequestActivity";
import { CommunityMembershipRequestDeclinedActivity } from "./CommunityMembershipRequestDeclinedActivity";

export type ActivityProps = {
	activity: AvailableNotificationViewModel;
	onActivityChanged: () => void;
};

export const ActivityContent = (props: ActivityProps): ReactElement | null => {
	const { activity, onActivityChanged } = props;

	switch (activity.kind) {
		case NotificationKind.CrossStoreOperation:
			return (
				<CrossStoreActivity
					data={activity.data}
					activityId={activity.id}
					onActivityChanged={onActivityChanged}
				/>
			);
		case NotificationKind.Maintenance:
			return <MaintenanceActivity data={activity.data} />;
		case NotificationKind.Announcement:
			return <AnnouncementActivity data={activity.data} />;
		case NotificationKind.NewMainAppPromotion:
			return <NewMainAppPromotionActivity data={activity.data} />;
		case NotificationKind.AppAccess:
			return <AppAccessActivity data={activity.data} />;
		case NotificationKind.Custom:
			return <CustomActivity data={activity.data} />;
		case NotificationKind.NewEmail:
			return <NewEmailActivity data={activity.data} />;
		case NotificationKind.UserRequest:
			return <UserRequestActivity data={activity.data} />;
		case NotificationKind.Birthday:
			return <BirthdayActivity data={activity.data} onActivityChanged={onActivityChanged} />;
		case NotificationKind.BirthdayWish:
			return <BirthdayWishActivity data={activity.data} onActivityChanged={onActivityChanged} />;
		case NotificationKind.BirthdayWishReaction:
			return <BirthdayWishReactionActivity data={activity.data} />;
		case NotificationKind.AnnouncementComment:
			return <AnnouncementCommentActivity data={activity.data} />;
		case NotificationKind.DocumentShared:
			return <DocumentSharedActivity data={activity.data} />;
		case NotificationKind.KnowledgeItem:
			return <KnowledgeItemActivity data={activity.data} />;
		case NotificationKind.Event:
			return <EventActivity data={activity.data} />;
		case NotificationKind.AnnouncementCommentReaction:
			return <AnnouncementCommentReactionActivity data={activity.data} />;
		case NotificationKind.AnnouncementReaction:
			return <AnnouncementReactionActivity data={activity.data} />;
		case NotificationKind.EventAttendance:
			return <EventAttendanceActivity data={activity.data} />;
		case NotificationKind.AnnouncementCommentMention:
			return <AnnouncementCommentMentionActivity data={activity.data} />;
		case NotificationKind.CommunityPostComment:
			return <CommunityPostCommentActivity data={activity.data} />;
		case NotificationKind.CommunityPostCommentMention:
			return <CommunityPostCommentMentionActivity data={activity.data} />;
		case NotificationKind.CommunityPost:
			return <CommunityPostActivity data={activity.data} />;
		case NotificationKind.CommunityPostReaction:
			return <CommunityPostReactionActivity data={activity.data} />;
		case NotificationKind.CommunityPostCommentReaction:
			return <CommunityPostCommentReactionActivity data={activity.data} />;
		case NotificationKind.EventComment:
			return <EventCommentActivity data={activity.data} />;
		case NotificationKind.EventCommentReaction:
			return <EventCommentReactionActivity data={activity.data} />;
		case NotificationKind.EventCommentMention:
			return <EventCommentMentionActivity data={activity.data} />;
		case NotificationKind.EventReaction:
			return <EventReactionActivity data={activity.data} />;
		case NotificationKind.KnowledgeItemComment:
			return <KnowledgeItemCommentActivity data={activity.data} />;
		case NotificationKind.KnowledgeItemCommentReaction:
			return <KnowledgeItemCommentReactionActivity data={activity.data} />;
		case NotificationKind.KnowledgeItemCommentMention:
			return <KnowledgeItemCommentMentionActivity data={activity.data} />;
		case NotificationKind.KnowledgeItemReaction:
			return <KnowledgeItemReactionActivity data={activity.data} />;
		case NotificationKind.Community:
			return <CommunityActivity data={activity.data} />;
		case NotificationKind.CommunityMembership:
			return <CommunityMembershipActivity data={activity.data} />;
		case NotificationKind.CommunityMembershipRequested:
			return <CommunityMembershipRequestActivity data={activity.data} />;
		case NotificationKind.CommunityMembershipRequestDeclined:
			return <CommunityMembershipRequestDeclinedActivity data={activity.data} />;
		case NotificationKind.Unknown:
			console.warn(`Cannot render an activity with unknown kind`);
			return null;
		default:
			never(activity);
	}
};

ActivityContent.displayName = "ActivityContent";